import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/logo/AcrossLogo.png";

interface SidebarProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

const navItems = [
  {
    label: "Dashboard",
    to: "/admin",
    icon: (
      <svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        viewBox="0 0 24 24"
      >
        <rect x="3" y="3" width="7" height="7" rx="2" fill="#2563eb" />
        <rect x="14" y="3" width="7" height="7" rx="2" fill="#059669" />
        <rect x="14" y="14" width="7" height="7" rx="2" fill="#f59e42" />
        <rect x="3" y="14" width="7" height="7" rx="2" fill="#a2 1caf" />
      </svg>
    ),
    activeColor: "bg-blue-100 text-blue-700",
    iconColor: "text-blue-600",
  },
  {
    label: "Blog Pages",
    to: "/admin/blogs",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
        <rect x="4" y="3" width="16" height="18" rx="2" fill="#059669" />
        <rect x="7" y="7" width="10" height="2" rx="1" fill="#fff" />
        <rect x="7" y="11" width="10" height="2" rx="1" fill="#fff" />
        <rect x="7" y="15" width="6" height="2" rx="1" fill="#fff" />
      </svg>
    ),
    activeColor: "bg-green-100 text-green-700",
    iconColor: "text-green-600",
  },
  {
    label: "Jobs Pages",
    to: "/admin/jobs",
    icon: (
      <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24">
        <rect x="3" y="7" width="18" height="13" rx="2" fill="#2563eb" />
        <path
          d="M8 7V5a4 4 0 0 1 8 0v2"
          stroke="#fff"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    ),
    activeColor: "bg-blue-100 text-blue-700",
    iconColor: "text-blue-600",
  },
];

const Sidebar: React.FC<SidebarProps> = ({ open, setOpen }) => {
  const location = useLocation();

  return (
    <aside
      className={`fixed md:static top-0 left-0 h-full z-40 bg-white text-gray-900 flex flex-col shadow-lg transition-transform duration-300
        ${open ? "translate-x-0" : "-translate-x-full"} md:translate-x-0 w-64`}
    >
      <div className="p-6 font-bold text-xl border-b border-gray-200 flex justify-between items-center">
        <img src={logo} alt="Across Logo" className="h-10 w-auto" />
        <button
          className="md:hidden text-gray-900 text-2xl ml-2"
          onClick={() => setOpen(false)}
        >
          &times;
        </button>
      </div>
      <nav className="flex-1 p-4 flex flex-col justify-between">
        <div>
          <ul className="space-y-2">
            {navItems.map((item) => {
              const isActive =
                location.pathname === item.to ||
                (item.to !== "/admin" && location.pathname.startsWith(item.to));
              return (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    onClick={() => setOpen(false)}
                    className={`flex items-center gap-3 px-4 py-2 rounded font-medium transition
                      ${
                        isActive
                          ? `${item.activeColor} shadow`
                          : "hover:bg-gray-100 text-gray-700"
                      }`}
                  >
                    <span
                      className={`inline-flex items-center justify-center ${
                        isActive ? item.iconColor : "text-gray-400"
                      }`}
                    >
                      {item.icon}
                    </span>
                    <span>{item.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
        <button
          className="w-full py-2 bg-red-500 text-white rounded shadow hover:bg-red-600 transition mb-2"
          onClick={() => {
            localStorage.removeItem("admin_token");
            window.location.href = "/login";
          }}
        >
          Logout
        </button>
      </nav>
    </aside>
  );
};

export default Sidebar;
